import axios from 'axios';

const CONSENT_ENDPOINT =
  'https://us-central1-playbook-app-98755.cloudfunctions.net/recordConsent';

export async function recordConsent(data) {
  const response = await axios.post(CONSENT_ENDPOINT, data, {
    timeout: 5000,
  });

  if (!response?.data?.recordId || !response?.data?.acceptedAt) {
    throw new Error('Consent record response was incomplete.');
  }

  return response.data;
}
